import React, { useState } from "react";
import "./Reviews.scss";
import withMotion from "../../Utils/withMotion";

//Images
import rr from "./images/rr-testimonial.png";
import sl from "./images/sl-testimonial.png";
import sb from "./images/sb-testimonial.png";
import ma from "./images/ma-testimonial.png";
import hr from "./images/hr-testimonial.png";
import rg from "./images/rr-testimonial.png";

// SEO
import SEO from "../../SEO/index.js";

const Reviews = () => {
  const [rev1, setrev1] = useState(false);
  const [rev2, setrev2] = useState(false);
  const [rev3, setrev3] = useState(false);
  const [rev4, setrev4] = useState(false);
  const [rev5, setrev5] = useState(false);
  const [rev6, setrev6] = useState(false);

  return (
    <>
      <SEO 
        title="Reviews & Customer Testimonials | Pacific Pavingstone"
        description="We stand behind the quality of our work. But, don't just take our word for it, see what our loyal customers have to say about the projects we've completed for them."
        profileURL={"https://www.pacificpavingstone.com/reviews"}
        type="website"
      />
      <div className="container-fluid">
        <div className="row justify-content-center page-reviews mb-5">
          <div className="col-11">
            <h1 className="text-center text-uppercase">
              What our customers are saying 
            </h1>
            <div className="row justify-content-around review-list mt-5">
              <div className="col-10 col-md-8 col-lg-3 mt-3 mt-lg-0 review-item">
                <div className="row">
                  <div className="col-3">
                    <img src={rr} alt="Profile" />
                  </div>
                  <div className="col-9 text-left">
                    <p>
                      R.R.
                      <br />
                      Studio City, CA
                    </p>
                  </div>
                </div>
                <div className="row testimony mt-3">
                  <div className="col-12">
                    <p>
                      “Every once in a while I come across a contractor whose
                      standards are exceptional on all levels. Pacific
                      Pavingstone is one of those contractors! They recently
                      installed an 1,100 sq ft paver stone driveway, numerous
                      cantilevered concrete steps, board formed concrete planter
                      walls and landscaping that is of the highest quality and
                      that we just LOVE! Furthermore,
                      {!rev1 ? (
                        "..."
                      ) : (
                        <>
                          Trent, John, Luis and their entire staff were always a
                          pleasure to work with and the entire experience was
                          easy and stress-free too! If you want a contractor
                          that is professional, does outstanding quality work
                          and one that you will not lose any sleep over, Pacific
                          Pavingstone is the one for you!
                        </>
                      )}{" "}
                      "
                    </p>
                    <button onClick={() => setrev1(!rev1)}>
                      {rev1 ? "Show Less" : "Continue reading"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-10 col-md-8 col-lg-3 mt-3 mt-lg-0 review-item">
                <div className="row">
                  <div className="col-3">
                    <img src={sl} alt="Profile" />
                  </div>
                  <div className="col-9 text-left">
                    <p>
                      S.L.
                      <br />
                      Calabasas, CA
                    </p>
                  </div>
                </div>
                <div className="row testimony mt-3">
                  <div className="col-12">
                    <p>
                      “This company is one of the best and most ethical company
                      I have ever worked with. I have had extensive remodeling
                      at my house. No one I mean no one has ever been more
                      responsible and punctual. They finished my driveway a week
                      ahead of schedule. I'm very impressed. Even after the job
                      was done they contacted me and wanted to make sure we were
                      happy. The crew and supervisor
                      {!rev2 ? (
                        "..."
                      ) : (
                        <>
                          Craig Jorge Onicemo, Hugo and Javier are all fantastic
                          and professional group. Trust me if need any work done
                          these guys are very legit and impressive. You would
                          not regret it. Their work is very clean and design is
                          amazing. Thank you Pacific paving Stone, GREAT JOB
                        </>
                      )}{" "}
                      "
                    </p>
                    <button onClick={() => setrev2(!rev2)}>
                      {rev2 ? "Show Less" : "Continue reading"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-10 col-md-8 col-lg-3 mt-3 mt-lg-0 review-item">
                <div className="row">
                  <div className="col-3">
                    <img src={sb} alt="Profile" />
                  </div>
                  <div className="col-9 text-left">
                    <p>
                      S.B.
                      <br />
                      S.B. Pasadena, CA
                    </p>
                  </div>
                </div>
                <div className="row testimony mt-3">
                  <div className="col-12">
                    <p>
                      I highly recommend Pacific Pavingstone for any paving job.
                      They recently added a beautiful patio of pavers to our
                      backyard and we couldn't be happier with the result. Craig
                      came out to give us an estimate for our small job and
                      spent a considerable amount of time with us, going over
                      all our options. His team even dropped off some sample
                      pavers when we couldn't decide
                      {!rev3 ? (
                        "..."
                      ) : (
                        <>
                          what color to go with so we could see it in-place.
                          Onecimo and his crew were awesome and made sure we
                          were happy as the job progressed. No detail was too
                          small for them to take the time to do it right and
                          make sure it looked good. They left the job site clean
                          at the end of every day and were very professional.
                          They also started and finished the job in the exact
                          timeframe they said they would.
                          <br />
                          <br />
                          Like a few others mentioned, they weren't the cheapest
                          estimate but you get what you pay for. This is a good
                          company that was easy to work with and installed a
                          quality product. Highly recommend!
                        </>
                      )}{" "}
                      "
                    </p>
                    <button onClick={() => setrev3(!rev3)}>
                      {rev3 ? "Show Less" : "Continue reading"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-10 col-md-8 col-lg-3 mt-3 mt-lg-0 review-item">
                <div className="row">
                  <div className="col-3">
                    <img src={ma} alt="Profile" />
                  </div>
                  <div className="col-9 text-left">
                    <p>
                      M.A.
                      <br />
                      Burbank, CA
                    </p>
                  </div>
                </div>
                <div className="row testimony mt-3">
                  <div className="col-12">
                    <p>
                      My husband and I decided it was finally time to re-do our
                      backyard.  We needed everything done- hardscape and
                      landscape.  I didn't have any connections with an outdoor
                      contractor, so we just set up consultations with a few
                      companies.  We decided to go with Pacific
                      Pavingstone/Pacific Outdoor Living for many reasons -
                      their professionalism, all work is
                      {!rev4 ? (
                        "..."
                      ) : (
                        <>
                          done in-house, they do just about anything and their
                          PRICE!  WE COULD NOT HAVE MADE A BETTER CHOICE!!!! At
                          first I was a bit worried we would get buried under
                          bigger design projects.  Pacific Pavingstone does some
                          really huge, amazing projects...I saw their gallery.
                           We needed everything done, but have a small backyard.
                           They treated our project with what felt like high
                          priority.  I really appreciated that it seems they
                          view every project as equal.
                          <br />
                          <br />
                          This company was professional, kind, informative and
                          really just the easiest company to work with.  We were
                          happy from the initial consultation and design with
                          Andrew, to the office staff (Jessica), to our project
                          manager (Jorge), to the paving crew, to the
                          landscaping manager (Daniel) and crew, to the
                          electricians, to the final walk through!!!  The crews
                          worked very hard and were all very nice!   We are so
                          absolutely thrilled with how our backyard turned
                          out!!!!  Would 100% recommend this company! Thank you
                          to everyone at Pacific Pavingstone for giving us the
                          backyard our our dreams!!!!
                        </>
                      )}{" "}
                      "
                    </p>
                    <button onClick={() => setrev4(!rev4)}>
                      {rev4 ? "Show Less" : "Continue reading"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-10 col-md-8 col-lg-3 mt-3 mt-lg-0 review-item">
                <div className="row">
                  <div className="col-3">
                    <img src={hr} alt="Profile" />
                  </div>
                  <div className="col-9 text-left">
                    <p>
                      H.R.
                      <br />
                      Los Angeles, CA
                    </p>
                  </div>
                </div>
                <div className="row testimony mt-3">
                  <div className="col-12">
                    <p>
                      We used Pacific Pavingstone to pave the front of our house
                      and it has amazingly transformed the look of the house.
                       Ken was helpful with the design to capture what we wanted
                      and answered all of our questions. Onecimo and his crew
                      delivered exactly what we wanted even when we challenged
                      them with additional requests. Everyone was punctual
                      everyday and communication was
                      {!rev5 ? (
                        "..."
                      ) : (
                        <>
                          excellent even returning calls after hours. We are
                          looking forward to their services on the backyard
                          project. I would recommend their services to
                          everyone. 
                        </>
                      )}{" "}
                      "
                    </p>
                    <button onClick={() => setrev5(!rev5)}>
                      {rev5 ? "Show Less" : "Continue reading"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-10 col-md-8 col-lg-3 mt-3 mt-lg-0 review-item">
                <div className="row">
                  <div className="col-3">
                    <img src={rg} alt="Profile" />
                  </div>
                  <div className="col-9 text-left">
                    <p>
                      R.G.
                      <br />
                      Los Angeles, CA
                    </p>
                  </div>
                </div>
                <div className="row testimony mt-3">
                  <div className="col-12">
                    <p>
                      We hired Pacific Pavingstone to replace our concrete
                      driveway and pool deck with paving stones. From the
                      initial consultation, through the multifaceted
                      installation process, and completion, they were top notch-
                      professional, courteous, and responsive. At one point
                      there were some issues with sealing our pool coping, but
                      they took the time to find an
                      {!rev6 ? (
                        "..."
                      ) : (
                        <>
                          appropriate solution with a perfect outcome. <br />
                          <br />
                          Another aspect of the job involved in-ground lighting,
                          which was challenging and tricky/ they handled it
                          expertly. All in all, we would highly recommend
                          Pacific Pavingstone, and would bring them back without
                          reservation. The results of our yard makeover were
                          exceptional, and we never fail to receive compliments-
                          design and beauty were a definite enhancement to our
                          home!
                        </>
                      )}{" "}
                      "
                    </p>
                    <button onClick={() => setrev6(!rev6)}>
                      {rev6 ? "Show Less" : "Continue reading"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withMotion(Reviews);
